import React, { useEffect, useState } from 'react'
import classes from "./style.module.scss"
import { Iconfont } from '../../../../components/icon/iconfont'
import BottomToTop from '../../../../components/transitions/bottom-to-top'
import { BlackMask } from '../../../../components/mask'
import { useIntl, FormattedMessage } from 'react-intl'
import deeplink from '../../../../../utils/deeplink'
import useStyles from 'isomorphic-style-loader/useStyles'
import { getSensorsUrl } from '../../../../utils/sensor'

const ProductOffInfoItem = props => {
    const { show, onClose, promList, productId, couponList } = props
    const intl = useIntl();

    useEffect(() => {
        if (show) {
            if (window.GeekoSensors) {
                promList?.forEach?.((p, index) => {
                    window.GeekoSensors.Track('PitPositionExposure', {
                        resourcepage_title: 'product',
                        resource_position: index + 1,
                        resource_type: '2',
                        resource_content: p?.description
                    })
                })
            }
        }
    }, [show])

    const go = (url, { title, description, id }, position) => {
        onClose()
        if (window.GeekoSensors) {
            window.GeekoSensors.Track('PitPositionClick', {
                resourcepage_title: 'product',
                resource_position: position,
                resource_type: '2',
                resource_content: description
            })
        }
        let href;

        if (url.indexOf("?") != -1) {
            if (url.split("?")[1]) {
                href = url + '&productId=' + productId + '&activityId=' + id
            } else {
                href = url + 'productId=' + productId + '&activityId=' + id
            }
        } else {
            href = url + '?productId=' + productId + '&activityId=' + id
        }

        window.location.href = getSensorsUrl(href, {
            resourcepage_title: 'product',
            resource_position: position,
            resource_type: '2',
            resource_content: description
        })
    }

    return <React.Fragment>
        <Iconfont className={classes.offMaskCloseIcon} onClick={onClose}>&#xe7c9;</Iconfont>
        {
            promList && promList.length > 0 &&
            <>
                <div className={classes.promotionTitle}>
                    <FormattedMessage id="promotions" />
                </div>
                <div className={classes.promotionList}>
                    {
                        promList.map((p, i) => (
                            <div className={classes.promotionItem} key={i} onClick={() => go(deeplink(p?.deepLink, "msite"), p, i + 1)}>
                                <div className={classes.tag}>{p.title}</div>
                                <div className={classes.promotionDes}>{p.description}</div>
                                <Iconfont className={classes.toCollectionIcon} >&#xe694;</Iconfont>
                            </div>
                        ))
                    }
                </div>
            </>
        }

        {/* {
            couponList && couponList.length > 0 &&
            <>
                <div className={classes.promotionTitle}>
                    <FormattedMessage id="coupons" />
                </div>
                <div className={classes.couopnList}>
                    {
                        couponList.map((c, i) => (
                            <div className={classes.couponItem}>
                                <div className={classes.couponLeft}>
                                    <div className={classes.couponMain}>
                                        {
                                            c.name &&
                                            <div className={classes.couponName}>{c.name}</div>
                                        }
                                        {
                                            c.condition &&
                                            <div className={classes.couponContent}>{c.condition}</div>
                                        }
                                        {
                                            c.description &&
                                            <div className={classes.couponContent}>{c.description}</div>
                                        }
                                    </div>
                                </div>
                                <div className={classes.couponRight}>

                                </div>
                                
                                

                            </div>
                        ))
                    }
                </div>
            </>
        } */}
    </React.Fragment>
}

const ProductOffInfoModal = (props) => {
    const { show, onClose } = props



    return (
        <React.Fragment>
            <BottomToTop in={show} className={classes.offMask}>
                <div>
                    <ProductOffInfoItem {...props} />
                </div>
            </BottomToTop>

            {
                show && <BlackMask onClick={onClose} />
            }

        </React.Fragment>
    )
}


const ProductOffInfo = (props) => {
    useStyles(classes);

    const { promotions, productId, setShowProm } = props

    const [showMore, setShowMore] = useState(false)

    const showMoreInfo = () => {
        setShowMore(!showMore)
        // setShowProm(true)
    }

    return promotions?.length > 0 && <div className={classes.ProductOffInfoBox} onClick={() => showMoreInfo()}>
        <div className={classes.ProductOffInfoTitle}>
            <span><FormattedMessage id="promotions" defaultMessage={'Promotions'} /></span>
            <span className={classes.right}>
                <FormattedMessage id="get_coupon" defaultMessage={'Get Coupon'} />
                <Iconfont className={classes.GetCouponIcon}>&#xe694;</Iconfont>
            </span>
        </div>
        <div className={classes.ProductOffInfoContent}>
            <Iconfont className={classes.offIcon}>&#xe7e9;</Iconfont>

            <div className={classes.tagsList}>
                <div className={classes.tagsScrollList}>
                    {
                        promotions?.map?.((t, index) => (
                            <div className={classes.tag} key={index}>
                                {t?.subTitle || t?.name}{t?.condition ? ' '+t?.condition: ''}
                            </div>
                        ))
                    }
                </div>
            </div>

            {/* <Iconfont className={classes.toPageIcon} >&#xe694;</Iconfont> */}
        </div>


        <ProductOffInfoModal
            show={showMore}
            promList={promotions}
            couponList={promotions}
            productId={productId}
            onClose={() => showMoreInfo()} />
    </div>
}
export default ProductOffInfo